(()=>{
 const start=()=>{
  const search=document.querySelector('.product-search-dialog');
  document.querySelector('[data-product-search]')?.addEventListener('click',()=>search?.showModal());
  search?.querySelector('[data-search-close]')?.addEventListener('click',()=>search.close());
  search?.querySelector('input')?.addEventListener('input',e=>search.querySelectorAll('a').forEach(a=>a.hidden=!a.textContent.toLowerCase().includes(e.target.value.toLowerCase())));
  function sticky(){
   const box=document.querySelector('.sticky-buy');if(!box)return;
   const heading=document.querySelector('.product-copy h1');
   if(heading)box.querySelector('strong').textContent=heading.textContent.replace(/lichtRood/,'licht Rood').replace(/licht(?=[A-Z])/,'licht ');
   const qty=Number(document.querySelector('[name=catalogquantity]:checked,[name=bundle]:checked,[name=quantity]:checked')?.value||1);
   const compare=document.querySelector('.price-compare');
   box.querySelectorAll('.sticky-price-compare,.sticky-price-saving').forEach(n=>n.remove());
   if(compare&&!compare.hidden&&compare.textContent.trim()){
    const n=Number(compare.textContent.replace(/[^\d,]/g,'').replace(',','.'));
    const del=document.createElement('del');del.className='sticky-price-compare';del.textContent=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(n*qty);
    box.querySelector('small').append(del);
    const tag=document.createElement('span');tag.className='sticky-price-saving';tag.textContent=document.querySelector('.price-saving span')?.textContent||'';
    if(qty===1&&tag.textContent)box.querySelector('small').append(tag);
   }
   const model=document.querySelector('[name=model]:checked');const legend=document.querySelector('#lichtros-product-form fieldset .step-label');
   if(model&&legend)legend.textContent='Kies je model: '+(model.value==='pro'?'Pro 16':'Original');
  }
  sticky();document.addEventListener('change',()=>requestAnimationFrame(sticky));
  const bar=document.querySelector('.sticky-buy'),anchor=document.querySelector('[data-buy-anchor]');
  if(bar&&anchor){
   const visibility=()=>bar.classList.toggle('visible',anchor.getBoundingClientRect().bottom<0);
   window.addEventListener('scroll',visibility,{passive:true});window.addEventListener('resize',visibility);
   requestAnimationFrame(visibility);
  }
 };
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start):start();
})();
